module.exports = __webpack_public_path__ + "static/media/bg-piece-collection-btn.620c1331.png";